export class ProjectDataPuerta {

	public idPuerta: string;

	public idModeloPanel: string;

	public idModeloPuerta: string;
	public idTipoPuerta: string;
	public idColor: string;

	public alturaPuerta: number;
	public alturaValor?: number;
	public longitudPuerta: number;

	public lat: number;
	public lng: number;

	public puerta: any;

	public bayoneta: any;

	public seqPuerta: number = -1; // OLD no se usa.
	public lsp: number = 9999;
	public idSVG?: string;
	public margen?: number; // Tango por ciento des el primer punto.
}
